import React, { useState, useEffect, useContext } from "react";

// Package import
import {
  Box,
  Typography,
  Grid,
  Menu,
  MenuItem,
  Fade,
  Paper,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Divider,
  Chip,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Pagination,
  Stack,
  Tooltip,
} from "@mui/material";
import { Search as SearchIcon } from "@mui/icons-material";
import { menuClasses } from "@mui/material/Menu";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

// User Import

import { pouRoutes, RoutesUrls } from "../../../Services/Routes/APP";
import { headersPost } from "../../../Services/API";
import { POU_API_ULRS } from "../../../Services/Routes/API";
import { getPagination } from "../../../common/functions";
import { ministry_Context } from "../../../context";
import { RetireIcon, TransferIcon } from "../../../Svg";
import { useDecodedToken } from "../../../Services/Routes/APP/PrivateRoute";

// Constants

const headings = [
  "Batch #",
  "Lot #",
  "Available Quantity",
  "Issued Date",
  "Type",
  "MFG",
  "Exp Date",
  "Actions",
];

//component

const Batch = () => {
  // Hooks
  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();

  //states

  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [api, setApi] = useState(false);
  // const [product, setProduct] = useState(null)
  const [totalCount, setTotalCount] = useState(0);
  const [batches, setBatches] = useState([]);
  const [filteredBatch, setFilteredBatch] = useState([]);
  const [searched, setSearched] = useState("");
  const [searchData, setSearchData] = useState("");

  // Constants
  const openMenu = Boolean(anchorEl);

  //menu open handler

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //create batch handler

  const createBatchHandler = () => {
    // navigate(RoutesUrls?.provinceAdmin + ministryRoutes?.create_batch);
  };

  //close alert

  const closeHandler = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  //batches

  const getBatches = () => {
    const data = {
      page: page,
    };
    setOpen(true);

    headersPost(POU_API_ULRS.GET_ALL_BATCHES, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setBatches(res?.data?.batches);
          setFilteredBatch(res?.data?.batches);
          setTotalCount(res?.data?.total_count);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //life cycle

  useEffect(() => {
    getBatches();
  }, [api]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setApi(true);
  };

  const transferHandler = (row) => {
    navigate(RoutesUrls?.pouAdmin + pouRoutes?.issuedBatch, {
      state: {
        node: row,
      },
    });
  };

  //retire batch

  const retireHandler = (row) => {
    navigate(RoutesUrls?.pouAdmin + pouRoutes?.retireBatch, {
      state: {
        node: row,
      },
    });
  };
  // search
  const requestSearch = (searchedVal) => {
    const filteredRows = batches.filter((row) => {
      return row.reference_number.toLowerCase().includes(searchedVal.toLowerCase());
    });
    setFilteredBatch(filteredRows);
  };

  //render
  return (
    <>
      <Box padding={2}>
        {/* <Box
            display={{ md: "flex", sm: "flex" }}
            justifyContent={{ md: "space-between", sm: "space-between" }}
          >
            <Grid container>
              <Grid item sx={{ p: 1 }}>
                <Typography variant="h5" m={0.5}>
                  Inventory Information
                </Typography>
                <Typography component={"span"} m={0.5} color="text.secondary">
                  Updated 30 minutes before
                </Typography>
              </Grid>
            </Grid> */}
        {/* <Box display={{ xs: "flex" }} justifyContent={{ xs: "right" }}>
              <Box
                display={{ xs: "flex" }}
                justifyContent={{ xs: "right" }}
                mb={2}
              > */}
        {/* <Button
                  color="primary"
                  variant="contained"
                  size="large"
                  id="fade-button"
                  aria-controls="fade-menu"
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                  sx={{
                    borderRadius: 2,
                    maxHeight: 40,
                    minWidth: 150,
                  }}
                >
                  Actions
                </Button> */}
        {/* Dropdown */}
        {/* <Menu
                  anchorEl={anchorEl}
                  open={openMenu}
                  onClose={handleClose}
                  TransitionComponent={Fade}
                  sx={{
                    [`& .${menuClasses.root}`]: {
                      paddingRight: 4,
                      paddingLeft: 4,
                    },
                  }}
                >
                  <MenuItem onClick={createBatchHandler}>Create Batch</MenuItem>
                  <Divider /> */}
        {/* <MenuItem onClick={handleClose}>Units Used</MenuItem>
                  <Divider />
                  <MenuItem onClick={handleClose}>Isued Batch</MenuItem>
                  <Divider />
                  <MenuItem onClick={handleClose}>Recieved Batch</MenuItem>
                  <Divider />
                  <MenuItem onClick={handleClose}>Requested Batch</MenuItem> */}
        {/* </Menu>
              </Box>
            </Box> */}
        {/* Table */}
        {/* </Box> */}
        <Box display={"flex"} justifyContent={"flex-end"} mt={2} mb={2}>
          <TextField
            size="small"
            type="search"
            placeholder="Search by Batch No #"
            value={searched}
            onChange={(e) => {
              setSearched(e.target.value);
              requestSearch(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <SearchIcon
                  sx={{
                    color: theme.palette.primary.dark,
                  }}
                />
              ),
            }}
            sx={{
              borderRadius: 25,
              backgroundColor: theme.palette.secondary.dark,
              [`.${outlinedInputClasses.root}`]: {
                borderRadius: 25,
                paddingX: 2,
              },
            }}
          ></TextField>
        </Box>
        <Paper elevation={1} sx={{ borderRadius: 3 }}>
          <TableContainer>
            <Table sx={{ marginTop: 5 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {headings?.map((h, index) => (
                    <TableCell
                      sx={{
                        fontWeight: "bold",
                      }}
                      align="center"
                      key={`${index}-table-heading-${h}`}
                    >
                      <Chip
                        label={h}
                        sx={{
                          backgroundColor:
                            index === headings.length - 1
                              ? `${theme.palette.error.light}`
                              : `${theme.palette.secondary.dark}`,
                          borderRadius: 2,
                          color:
                            index === headings.length - 1
                              ? `${theme.palette.error.main}`
                              : `${theme.palette.primary.main}`,
                        }}
                      ></Chip>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredBatch.length > 0 ? (
                  filteredBatch?.map((row, index) => (
                    <TableRow
                      key={`${index}-row.name-${index + 21}`}
                      sx={{
                        backgroundColor: row?.is_expired
                          ? theme.palette.error.light
                          : "none",
                      }}
                    >
                      <TableCell align="center">
                        {row?.reference_number}
                      </TableCell>
                      <TableCell align="center">{row?.lot_number}</TableCell>
                      <TableCell align="center">
                        {row?.available_quantity}
                      </TableCell>
                      <TableCell align="center">
                        {row?.created_at
                          ? format(new Date(row?.created_at), "MM/dd/yyyy")
                          : ""}
                      </TableCell>
                      <TableCell align="center">{row?.sub_type}</TableCell>
                      <TableCell align="center">
                        {row?.expiry_date
                          ? format(
                            new Date(row?.manufacture_date),
                            "MM/dd/yyyy"
                          )
                          : "MM/dd/yyyy"}
                      </TableCell>
                      <TableCell align="center">
                        {row?.expiry_date
                          ? format(new Date(row?.expiry_date), "MM/dd/yyyy")
                          : "MM/dd/yyyy"}
                      </TableCell>
                      <TableCell align="center">
                        <Stack
                          direction="row"
                          spacing={2}
                          justifyContent={"center"}
                        >
                          <Tooltip title="Issued">
                            <Button
                              color="primary"
                              variant="contained"
                              size="small"
                              onClick={() => transferHandler(row)}
                              disabled={
                                row.available_quantity === 0 || row?.is_expired
                              }
                              sx={{
                                borderRadius: 1,
                                minWidth: 2,
                                paddingX: 1,
                                bgcolor: "#0C8968",
                              }}
                            >
                              <TransferIcon />
                            </Button>
                          </Tooltip>
                          <Tooltip title="Retire">
                            <Button
                              color="primary"
                              variant="contained"
                              size="small"
                              onClick={() => retireHandler(row)}
                              sx={{
                                borderRadius: 1,
                                minWidth: 2,
                                paddingX: 1,
                                bgcolor: "#FFA563",
                              }}
                              disabled={
                                row.available_quantity === 0 || row?.is_expired
                              }
                            >
                              <RetireIcon />
                            </Button>
                          </Tooltip>
                          {/* <Button
                          color="secondary"
                          variant="contained"
                          size="small"
                          sx={{
                            borderRadius: 2,
                          }}
                        >
                          Details
                        </Button> */}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    {" "}
                    <TableCell colSpan={8}>
                      {" "}
                      <Typography
                        width={"100%"}
                        variant="body1"
                        sx={{
                          textAlign: "center",
                        }}
                      >
                        {" "}
                        No Data Found
                      </Typography>{" "}
                    </TableCell>{" "}
                  </TableRow>
                )}
              </TableBody>
            </Table>
            <Box paddingTop={4} display={"flex"} justifyContent={"center"}>
              <Pagination
                count={totalCount > 10 ? getPagination(totalCount) : 1}
                page={page}
                onChange={handleChangePage}
                color="primary"
              />
            </Box>
          </TableContainer>
        </Paper>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={closeHandler}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={closeHandler} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Batch;
